import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../shareModule/services/common.service';
import { loadDiscount } from 'src/app/shareModule/states/nearby';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/shareModule/states/app.state';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

interface ContentItem {
  id?: number;
  title: string;
  content: string;
  icon: string;
  color: string;
  showTags?: boolean;
  _key?: string;
}

@Component({
  selector: 'app-edit-booking-content',
  templateUrl: './edit-booking-content.component.html',
  styleUrls: ['./edit-booking-content.component.scss'],
})
export class EditBookingContentComponent implements OnInit, OnDestroy {
  @Input() bookNowText: string = '';
  @Input() title: string = 'Book with Kachiing!';
  @Input() icon: string = '';
  @Input() description: string = 'Turns every booking into a win! Get instant cashback, rewards, and special discounts whenever you reserve with us.';
  @Input() connectionText: string = '';
  @Input() contentLists: any[] = [];
  @Input() filter: string = '';
  @Input() type: 'booking' | 'connection' = 'booking';
  @Input() color: string = 'primary';
  @Input() contentButtonMobileValue: boolean = false;
  @Input() buttonMobileTextValue: string = '';
  @Input() showTagsValue: boolean = true;
  @Output() contentSaved = new EventEmitter<{ title: string; icon: string; description: string }>();

  public editedTitle: string = '';
  public editedIcon: string = '';
  public editedDescription: string = '';
  public editedColor: string = 'primary';
  public editedBookNowText: string = '';
  public contentButtonMobile: boolean = false;
  public contentItems: ContentItem[] = [];
  public buttonMobileText: string = '';
  public showTags: boolean = true;
  public iconSelectorExpanded: { [key: string]: boolean } = {};
  public colorSelectorExpanded: { [key: string]: boolean } = {};
  public customIconFiles: { [key: string]: File } = {};
  public customIconPreview: { [key: string]: string } = {};
  public customIconUrls: { [key: string]: string } = {};

  // Promo-related icons for selection
  public promoIcons: string[] = [
    'fa-solid fa-crown',
    'fa fa-thumbs-up',
    'fas fa-gem',
    'fa-solid fa-lightbulb',
    'fa-solid fa-trophy',
    'fa-solid fa-fire',
    'fa-solid fa-medal',
    'fa-solid fa-heart',
    'fas fa-bolt',
    'fa-solid fa-star',
    'fa-solid fa-gift',
    'fa-solid fa-tag',
    'fa-solid fa-percent',
    'fa-solid fa-money-bill-wave',
    'fa-solid fa-calendar-check',
    'fa-solid fa-clock',
    'fa-solid fa-bell',
    'fa-solid fa-certificate',
  ];

  // Color options for selection
  public colorOptions: Array<{ name: string; value: string; hex: string }> = [
    { name: 'Primary', value: 'primary', hex: '#592880' },
    { name: 'Secondary', value: 'secondary', hex: '#b32596' },
    { name: 'Emerald', value: 'emerald', hex: '#10b981' },
    { name: 'Indigo', value: 'indigo', hex: '#4f46e5' },
    { name: 'Violet', value: 'violet', hex: '#7c3aed' },
    { name: 'Teal', value: 'teal', hex: '#14b8a6' },
    { name: 'Blue', value: 'blue', hex: '#3b82f6' },
    { name: 'Purple', value: 'purple', hex: '#9333ea' },
    { name: 'Pink', value: 'pink', hex: '#ec4899' },
    { name: 'Cyan', value: 'cyan', hex: '#06b6d4' },
  ];

  constructor(
    public modal: NgbActiveModal,
    public commonService: CommonService,
    private store: Store<AppState>,
    private customerService: CustomerService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.editedTitle = this.title;
    this.editedIcon = this.icon;
    this.editedDescription = this.description;
    this.editedColor = this.color || 'primary';
    this.editedBookNowText = this.bookNowText || '';
    this.contentButtonMobile = this.contentButtonMobileValue || false;
    this.buttonMobileText = this.buttonMobileTextValue || '';
    this.showTags = this.showTagsValue !== undefined ? this.showTagsValue : true;

    // Check if main icon is a URL (custom icon)
    if (this.icon && !this.icon.startsWith('fa-') && !this.icon.startsWith('fas ') && !this.icon.startsWith('fa-solid ')) {
      this.customIconUrls['main'] = this.icon;
      this.customIconPreview['main'] = environment.ImageUrl + this.icon;
    }

    // Initialize content items from contentLists
    console.log(this.contentLists, "this.contentLists")
    if (this.contentLists && this.contentLists.length > 0) {
      this.contentItems = this.contentLists.map((item: any, index: number) => {
        // Check if icon is a URL (custom icon) - store with item id as key for proper mapping
        const key = item.id ? 'content' + item.id : 'content' + index;
        if (item.icon && !item.icon.startsWith('fa-') && !item.icon.startsWith('fas ') && !item.icon.startsWith('fa-solid ')) {
          this.customIconUrls[key] = item.icon;
          this.customIconPreview[key] = environment.ImageUrl + item.icon;
        }
        return {
          id: item.id,
          title: item.title || '',
          content: item.content || '',
          icon: item.icon || '',
          color: item.color || 'primary',
          showTags: item.showTags !== undefined ? item.showTags : true,
          _key: key // Store key for reference
        };
      });
      // Sort by id, items without id go to the end
      this.contentItems.sort((a: any, b: any) => {
        if (!a.id && !b.id) return 0;
        if (!a.id) return 1;
        if (!b.id) return -1;
        return a.id - b.id;
      });
      this.cdr.detectChanges();
    }

    // If no content items, add one empty item
    if (this.contentItems.length === 0) {
      this.addContentItem();
    }
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    // Cleanup if needed
  }

  onIconSelected(icon: string) {
    // Toggle selection - if same icon clicked, deselect it
    if (this.editedIcon === icon) {
      this.editedIcon = '';
    } else {
      this.editedIcon = icon;
      // Clear custom icon if FontAwesome icon is selected
      if (this.customIconPreview['main']) {
        this.removeCustomIcon('main');
      }
    }
  }

  onCustomIconSelected(event: any, key: string) {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        this.toastr.error('Please select a valid image file');
        return;
      }
      
      // Validate file size (max 2MB)
      if (file.size > 2 * 1024 * 1024) {
        this.toastr.error('Image size should be less than 2MB');
        return;
      }

      this.customIconFiles[key] = file;
      
      // Create preview
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.customIconPreview[key] = e.target.result;
        this.cdr.detectChanges();
      };
      reader.readAsDataURL(file);

      // Clear FontAwesome icon if custom icon is selected
      if (key === 'main') {
        this.editedIcon = '';
      } else {
        // Find the content item by matching the key
        const item = this.contentItems.find((item: any) => {
          const itemKey = item.id ? 'content' + item.id : 'content' + this.contentItems.indexOf(item);
          return itemKey === key || item._key === key;
        });
        if (item) {
          item.icon = '';
        }
      }
    }
  }

  removeCustomIcon(key: string) {
    delete this.customIconFiles[key];
    delete this.customIconPreview[key];
    delete this.customIconUrls[key];
    this.cdr.detectChanges();
  }

  onColorSelected(color: string) {
    // Select the color
    this.editedColor = color;
  }

  getColorHex(colorValue: string): string {
    const color = this.colorOptions.find(c => c.value === colorValue);
    return color ? color.hex : '#592880';
  }

  isLightColor(hex: string): boolean {
    // Convert hex to RGB
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5;
  }

  onContentItemIconSelected(icon: string, index: number) {
    // Toggle selection - if same icon clicked, deselect it
    if (this.contentItems[index].icon === icon) {
      this.contentItems[index].icon = '';
    } else {
      this.contentItems[index].icon = icon;
      // Clear custom icon if FontAwesome icon is selected
      const key = 'content' + index;
      if (this.customIconPreview[key]) {
        this.removeCustomIcon(key);
      }
    }
  }

  addContentItem() {
    const index = this.contentItems.length;
    this.contentItems[this.contentItems.length] = {
      title: '',
      content: '',
      icon: '',
      color: 'primary',
      showTags: true,
      _key: 'content' + index
    };
    this.cdr.detectChanges();
  }

  toggleIconSelector(key: string) {
    this.iconSelectorExpanded[key] = !this.iconSelectorExpanded[key];
  }

  toggleColorSelector(key: string) {
    this.colorSelectorExpanded[key] = !this.colorSelectorExpanded[key];
  }

  onContentItemColorSelected(color: string, index: number) {
    this.contentItems[index].color = color;
  }

  removeContentItem(index: number) {
    if (this.contentItems.length > 1) {
      this.contentItems.splice(index, 1);
    }
  }

  trackByContentItem(index: number, item: ContentItem): any {
    return item.id || index;
  }

  save() {
    // Determine final icon value (custom icon URL or FontAwesome class)
    let finalIcon = this.editedIcon;
    if (this.customIconUrls['main']) {
      finalIcon = this.customIconUrls['main'];
    } else if (this.customIconPreview['main'] && !this.customIconFiles['main'] && !this.editedIcon) {
      // If there's a preview but no new file (existing icon), use the existing URL
      finalIcon = this.customIconUrls['main'] || this.icon;
    }

    // Create FormData to send everything in one request
    const formData = new FormData();
    
    // Add basic fields
    formData.append('filter', this.filter);
    
    if (this.type === 'booking') {
      formData.append('bookingTitle', this.editedTitle);
      formData.append('bookingIcon', finalIcon);
      formData.append('bookingDescription', this.editedDescription);
      formData.append('contentButtonMobile', this.contentButtonMobile.toString());
    } else {
      formData.append('connectionTitle', this.editedTitle);
      formData.append('connectionIcon', finalIcon);
      formData.append('connectionDescription', this.editedDescription);
      formData.append('contentButtonMobile', this.contentButtonMobile.toString());
      formData.append('showTags', this.showTags.toString());
      formData.append('buttonMobileText', this.buttonMobileText);
      formData.append('bookNowText', this.editedBookNowText);
      
      // Add main icon file if exists
      if (this.customIconFiles['main']) {
        formData.append('connectionIconUpload', this.customIconFiles['main']);
      }
      
      // Add content items data
      const contentItemsData = this.contentItems.map((item: any, index) => {
        const key = item._key || (item.id ? 'content' + item.id : 'content' + index);
        // Use custom icon URL if available, otherwise use FontAwesome icon
        let itemIcon = item.icon;
        if (this.customIconUrls[key]) {
          itemIcon = this.customIconUrls[key];
        } else if (this.customIconPreview[key] && !this.customIconFiles[key] && !item.icon) {
          itemIcon = this.customIconUrls[key] || item.icon;
        }
        
        return {
          id: item.id || undefined,
          title: item.title,
          content: item.content,
          icon: itemIcon,
          color: item.color,
          showTags: item.showTags !== undefined ? item.showTags : false
        };
      });
      
      formData.append('contentItems', JSON.stringify(contentItemsData));
      
      // Add content item icon files
      this.contentItems.forEach((item: any, index) => {
        const key = item._key || (item.id ? 'content' + item.id : 'content' + index);
        if (this.customIconFiles[key]) {
          formData.append(`contentIcon_${index}`, this.customIconFiles[key]);
        }
      });
    }

    // First, save the discount to get/create the discount ID
    this.customerService.createDiscount(formData).subscribe(
      (res) => {
        // After discount is saved, get the discount ID to use as contentId
        this.customerService.getDiscount({ filter: this.filter }).subscribe(
          (discountRes: any) => {
            const discountData = discountRes.body || discountRes;
            const discountId = discountData?.id;

            if (this.type === 'connection' && discountId) {
              // Get existing content items to find what needs to be deleted
              const existingContentList = discountData.contentLists || discountData.contentList || [];
              const existingIds = existingContentList.map((item: any) => item.id);
              const newIds = this.contentItems.filter(item => item.id).map(item => item.id!);
              const idsToDelete = existingIds.filter((id: number) => !newIds.includes(id));

              // Delete removed items
              const deleteRequests = idsToDelete.map((id: number) =>
                this.customerService.deleteContent(id).pipe(
                  catchError((err) => {
                    console.error(`Error deleting content ${id}:`, err);
                    return of(null); // Return null so forkJoin continues
                  })
                )
              );

              // Update or create content items
              const contentRequests = this.contentItems.map((item: any, index) => {
                // Use stored key or generate one
                const key = item._key || (item.id ? 'content' + item.id : 'content' + index);
                // Use custom icon URL if available, otherwise use FontAwesome icon
                let finalIcon = item.icon;
                if (this.customIconUrls[key]) {
                  finalIcon = this.customIconUrls[key];
                } else if (this.customIconPreview[key] && !this.customIconFiles[key] && !item.icon) {
                  // If there's a preview but no new file (existing icon), use the existing URL
                  finalIcon = this.customIconUrls[key] || item.icon;
                }
                
                // Create FormData for content item with icon file if exists
                const contentFormData = new FormData();
                contentFormData.append('contentId', discountId.toString());
                contentFormData.append('title', item.title);
                contentFormData.append('content', item.content);
                contentFormData.append('icon', finalIcon);
                contentFormData.append('color', item.color);
                contentFormData.append('showTags', (item.showTags !== undefined ? item.showTags : false).toString());
                
                if (item.id) {
                  contentFormData.append('id', item.id.toString());
                }
                
                // Add icon file if exists
                if (this.customIconFiles[key]) {
                  contentFormData.append('iconFile', this.customIconFiles[key]);
                }
                
                return this.customerService.createContent(contentFormData);
              });

              // Execute all requests in parallel
              const allRequests = [...deleteRequests, ...contentRequests];

              if (allRequests.length > 0) {
                forkJoin(allRequests).subscribe(
                  (results) => {
                    this.store.dispatch(loadDiscount({ filter: this.filter }));
                    this.toastr.success('Content updated successfully');
                    this.contentSaved.emit({
                      title: this.editedTitle,
                      icon: finalIcon,
                      description: this.editedDescription,
                    });
                    this.modal.close();
                  },
                  (err) => {
                    console.error('Error updating content items:', err);
                    this.toastr.error('Failed to update some content items');
                    this.store.dispatch(loadDiscount({ filter: this.filter }));
                    this.modal.close();
                  }
                );
              } else {
                // No content items, just refresh
                this.store.dispatch(loadDiscount({ filter: this.filter }));
                this.toastr.success('Content updated successfully');
                this.contentSaved.emit({
                  title: this.editedTitle,
                  icon: finalIcon,
                  description: this.editedDescription,
                });
                this.modal.close();
              }
            } else {
              // No content items to save, just refresh
              this.store.dispatch(loadDiscount({ filter: this.filter }));
              this.toastr.success('Content updated successfully');
              this.contentSaved.emit({
                title: this.editedTitle,
                icon: finalIcon,
                description: this.editedDescription,
              });
              this.modal.close();
            }
          },
          (getDiscountErr) => {
            console.error('Error getting discount:', getDiscountErr);
            this.toastr.error('Failed to get discount information');
            this.modal.close();
          }
        );
      },
      (err) => {
        console.error('Error creating discount:', err);
        this.toastr.error('Failed to update content');
        this.modal.close();
      }
    );
  }


  cancel() {
    this.modal.dismiss('Cancel click');
  }
}

